export default __webpack_public_path__ + "static/media/tut_revscreen.22682ad0.gif";